import { render, staticRenderFns } from "./_show.vue?vue&type=template&id=76c48eac"
import script from "./_show.vue?vue&type=script&lang=js"
export * from "./_show.vue?vue&type=script&lang=js"
import style0 from "./_show.vue?vue&type=style&index=0&id=76c48eac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports